import { Injectable } from '@angular/core';
import { GlobalHelper } from '../Common/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookstoreService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // Package Setup

  GetAllOneTimePackageSetup(data): Observable<any> {
    let param = 'strParameter=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/GetAllOneTimePackageSetup?'
      + encodeURI(param), { headers: reqHeader });
  }


  SaveOneTimePackage(data, List): Observable<any> {
    let param = 'obj=' + data + '&ObjItemList=' + List;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/SaveOneTimePackage?'
      + encodeURI(param), { headers: reqHeader });
  }

  //  Issue Package

  IssueOneTimePackageDetails(data): Observable<any> {
    let param = 'StudentID=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/IssueOneTimePackageDetails?'
      + encodeURI(param), { headers: reqHeader });
  }

  GetAllIssueOneTimePackage(data): Observable<any> {
    let param = 'strParameter=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/GetAllIssueOneTimePackage?'
      + encodeURI(param), { headers: reqHeader });
  }

  SaveIssueOneTimePackage(data, list): Observable<any> {
    let formData = new FormData();
    formData.append("obj", data);
    formData.append("ObjItemList", list);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/SaveIssueOneTimePackage', formData);
  }

  GetIssuePackageFeeReceipt(data): Observable<any> {
    let param = 'ReceiptNo=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/GetIssuePackageFeeReceipt?'
      + encodeURI(param), { headers: reqHeader });
  }

  UpdateIssuePayment(data): Observable<any> {
    let param = 'objdata=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/UpdateIssuePayment?'
      + encodeURI(param), { headers: reqHeader });
  }

  CancelIssueOneTimePackage(data): Observable<any> {
    let param = 'objModel=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/CancelIssueOneTimePackage?'
      + encodeURI(param), { headers: reqHeader });
  }

  // Stock Information

  GetStockInformation(data): Observable<any> {
    let param = 'InventoryModel=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/GetStockInformation?'
      + encodeURI(param), { headers: reqHeader });
  }

  // Item Day Wise Report

  GetIssueItemDayWiseReport(data): Observable<any> {
    let param = 'objdata=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/GetIssueItemDayWiseReport?'
      + encodeURI(param), { headers: reqHeader });
  }

  // Stationary Sell Report

  GetStationarySell(data): Observable<any> {
    let param = 'objModel=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/GetStationarySell?'
      + encodeURI(param), { headers: reqHeader });
  }

  // Package Print

  GetPackageDetails(data): Observable<any> {
    let param = 'PackageID=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Inventory/GetPackageDetails?'
      + encodeURI(param), { headers: reqHeader });
  }

}
